import React from "react";
import { useTranslation } from "react-i18next";

export function DeviceNotSoldWarning({ iconOnly = false }) {

    const { t } = useTranslation();
    const message = t("mod_device_search_status_not_sold");

    return (
        <span data-testid="device-not-sold-warning" className="text-warning" title={message}>
            &#9888;{!iconOnly && ` ${message}`}
        </span>
    );
}
